import "../../styles/Containers.css";
import "../../styles/Colors.css";
import OnBoarding from "./components/Onboarding";

function LoginOnboarding() {
  return (
    <div className="backPurple">
      <OnBoarding
        title="خوش اومدی به  فود پلنر"
        desc="اینجا خیالت از بابت برنامه غذایی راحت میشه!
        غذاهای مورد علاقه‌ت رو به راحتی یاد میگیری و
        برای درست کردنش برنامه ریزی میکنی."
        linkTo={["/login"]}
        bclass={["primaryWhite"]}
      />
    </div>
  );
}
export default LoginOnboarding;